
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlBuilder } from '../../core/url-builder/url-builder';
import { UserPermissionsStorage } from '../../user-permissions/user-permissions-storage';
import { User } from '../../user';

@Injectable()
export class SampleTrackingOptionResolver  {

    constructor(private urlBuilder: UrlBuilder, private permissionsStorage: UserPermissionsStorage) {

     }

    public navigate() {
        this.urlBuilder.esa().sampletracking().navigate();
    }

    public doesPermissionExists(currentUser: Observable<User>): Observable<boolean> {

        const isSponsor = currentUser.pipe(map(user => user.isSponsor));
        return isSponsor;
    }
}